import { get, post, put } from './fetcher';
import { API_ENDPOINTS } from '../config/api-config';

// 매수심리 타이밍 색상 기준 조회/저장
export const getSentimentTimingConfig = async () => {
  return get(API_ENDPOINTS.KB.SENTIMENT_TIMING_CONFIG);
};
export const saveSentimentTimingConfig = async (configs) => {
  return post(API_ENDPOINTS.KB.SENTIMENT_TIMING_CONFIG, configs);
};

// KB 데이터 동기화: 토큰 / 스케줄 / 즉시실행 / 상태
export const getKbToken = async () => get(API_ENDPOINTS.KB.TOKEN);
export const saveKbToken = async ({ token, apiTimestamp = null, memo = null }) =>
  put(API_ENDPOINTS.KB.TOKEN, { token, apiTimestamp, memo });
export const getKbSyncSchedule = async (category = 'KB') => get(API_ENDPOINTS.KB.SYNC_SCHEDULE, { category });
export const saveKbSyncSchedule = async (schedule) => put(API_ENDPOINTS.KB.SYNC_SCHEDULE, schedule);
export const runKbSyncNow = async (category = 'KB') =>
  post(`${API_ENDPOINTS.KB.SYNC_RUN_NOW}?category=${encodeURIComponent(category)}`, {});
export const getKbSyncStatus = async () => get(API_ENDPOINTS.KB.SYNC_STATUS);

// 홈 상단 KB 상태보드(주간/월간 지표) 조회 / 업데이트
export const getKbStatusBoard = async () => get(API_ENDPOINTS.KB.STATUS_BOARD);
export const updateKbStatusBoard = async (baseDate = null) =>
  post(baseDate ? `${API_ENDPOINTS.KB.STATUS_BOARD_UPDATE}?baseDate=${encodeURIComponent(baseDate)}` : API_ENDPOINTS.KB.STATUS_BOARD_UPDATE, {});

export const getKbTopRegions = async ({ indexType = 'SALE_IDX', limit = 10, regionId } = {}) => {
  return get(API_ENDPOINTS.KB.TOP_REGIONS, {
    indexType,
    limit,
    regionId,
  });
};

export const getKbRegions = async () => {
  return get(API_ENDPOINTS.KB.REGIONS);
};

export const getKbDataChartMulti = async ({ regionId, indexTypes = [], startDate, endDate, lookbackYears } = {}) => {
  if (!regionId) {
    throw new Error('regionId는 필수입니다.');
  }

  const types = Array.isArray(indexTypes) ? indexTypes.filter(Boolean).join(',') : '';
  if (!types) {
    throw new Error('indexTypes는 최소 1개 이상 필요합니다.');
  }

  return get(API_ENDPOINTS.KB.DATA_CHART_MULTI, {
    regionId,
    indexTypes: types,
    startDate,
    endDate,
    lookbackYears,
  });
};

export const getKbCompareChart = async ({ regionIds = [], indexType, startDate, endDate, lookbackYears } = {}) => {
  if (!Array.isArray(regionIds) || regionIds.length === 0) {
    throw new Error('regionIds는 필수이며 최소 1개 이상이어야 합니다.');
  }

  if (!indexType) {
    throw new Error('indexType은 필수입니다.');
  }

  const ids = regionIds.filter(Boolean).join(',');

  return get(API_ENDPOINTS.KB.DATA_CHART_COMPARE, {
    regionIds: ids,
    indexType,
    startDate,
    endDate,
    lookbackYears,
  });
};

// KB 피벗 표(지수/증감) - regionIds 로 선택 지역만 조회. sortOrder DESC(최신 상단) 기본.
export const getKbPivotTable = async ({ indexType, regionIds = [], startDate, endDate, sortOrder = 'DESC' } = {}) => {
  if (!indexType) {
    throw new Error('indexType은 필수입니다.');
  }
  const ids = Array.isArray(regionIds) ? regionIds.filter(Boolean).join(',') : '';
  return get(API_ENDPOINTS.KB.PIVOT_TABLE, {
    indexType,
    regionIds: ids,
    startDate,
    endDate,
    sortOrder,
  });
};

// KB 매수우위(매수매도심리) 피벗 표
export const getKbBuyerSentimentTable = async ({ regionIds = [], startDate, endDate } = {}) => {
  const ids = Array.isArray(regionIds) ? regionIds.filter(Boolean).join(',') : '';
  return get(API_ENDPOINTS.KB.PIVOT_BUYER_SENTIMENT, {
    regionIds: ids,
    startDate,
    endDate,
  });
};
